import { Star, Quote } from "lucide-react";
import Marquee from "react-fast-marquee";
import { testimonials, partnerLogos } from "@/data/testimonials";

export default function Testimonials() {
  return (
    <section className="bg-brand-ink text-white py-14 md:py-20 relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute inset-0 bg-grid-dark opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="overline" style={{ color: "#FF4500" }}>Témoignages</div>
            <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
              Ils ont transformé leur pratique avec YAFORMIS.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex -space-x-2">
              {testimonials.slice(0, 4).map((t) => (
                <img key={t.name} src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full border-2 border-brand-ink object-cover" />
              ))}
            </div>
            <div>
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} className="w-4 h-4 fill-brand-cta text-brand-cta" />
                ))}
              </div>
              <div className="text-xs text-slate-400 mt-0.5">4.9/5 · 200+ stagiaires</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="bg-white/[0.03] border border-white/10 p-7 md:p-8 hover:border-brand-cta transition-colors"
              data-testid={`testimonial-${t.name.replace(/\s/g, '-').toLowerCase()}`}
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <Star key={i} className="w-3.5 h-3.5 fill-brand-cta text-brand-cta" />
                  ))}
                </div>
                <span className="px-2.5 py-1 bg-white/5 border border-white/10 text-[10px] uppercase tracking-[0.18em] font-bold text-white/70">
                  Client vérifié
                </span>
              </div>
              <Quote className="w-7 h-7 text-brand-cta mt-5" strokeWidth={1.5} />
              <blockquote className="mt-3 text-base md:text-lg leading-relaxed text-slate-200 font-medium">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-white/10 flex items-center gap-3">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover" />
                <div className="flex-1">
                  <div className="font-heading font-bold text-white">{t.name}</div>
                  <div className="text-xs text-slate-400">{t.role}</div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] uppercase tracking-[0.15em] text-slate-500 font-semibold">Entreprise</div>
                  <div className="text-sm font-heading font-bold text-white mt-0.5">{t.company}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-12 pt-10 border-t border-white/10">
          <div className="overline mb-5 text-slate-400">Ils nous font confiance</div>
          <Marquee gradient gradientColor="#0A0A0A" gradientWidth={80} speed={30} pauseOnHover>
            {partnerLogos.map((p, i) => (
              <span key={i} className="font-heading font-bold text-2xl md:text-3xl text-slate-500 hover:text-white transition-colors mx-10">
                {p}
              </span>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
